module.exports = __webpack_public_path__ + "static/media/loc3_img22.c2043540.jpg";